<template>
  <div class="tooltip-content">
    <p class="message">
      {{ msg.message }}
    </p>
    <ul v-if="msg.list">
      <li v-for="item in msg.list" :key="item">
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "InfoTooltip",
  props: {
    msg: Object
  }
};
</script>

<style scoped></style>
